/**
 * Manifest page content — the association's English statement of intent, curated from MANIFEST.md
 * (the founder's own prose; presented faithfully, editorial notes and the Swedish stripped). Prose,
 * not data — kept as typed content so the page renders it with no DB or runtime markdown (research D9).
 */
export const manifest = {
  eyebrow: 'Manifest',
  title: 'Why we exist',
  lede: 'A manifesto is a statement of intent, not a rulebook. The binding rules live in the statutes. Here stands why we exist.',
  sections: [
    {
      heading: 'Who we are',
      paragraphs: [
        'Original Illuminati is a modern, open, non-profit network for people who value knowledge, reason, science, merit and compassion. We are inspired by the historical Illuminati order founded by Adam Weishaupt on 1 May 1776 — and by the whole Enlightenment’s faith that light, learning and free thought make the world better.',
        'We are not a secret society. We are not a continuation of the historical order, and make no claim to be it or its legal successor. We have nothing to do with the modern conspiracy myth. We are fully legal, transparent and democratic: public statutes, open finances, documented decisions. No secret rituals, no hidden agendas.',
      ],
    },
    {
      heading: 'What we believe',
      items: [
        ['Reason and science', 'We test claims against evidence, not against authority, tradition or wishful thinking. We change our minds when the evidence changes.'],
        ['Learning for life', 'Knowledge should be free and accessible. To learn and to teach is the most hopeful act a human being can perform.'],
        ['Compassion', 'Knowledge without compassion is cold and dangerous. We steward the legacy of the fine, humane work: charity, popular education and care for one another.'],
        ['Merit over power', 'Roles and standing are earned through contribution and skill, never through money, birth or dogma.'],
        ['Openness and democracy', 'We decide in open debate, record our decisions, and let them be tested. Transparency is not a risk for us; it is our method.'],
        ['Personal responsibility', 'We stand behind what we say and do, under our own names.'],
      ] as [string, string][],
    },
  ],
  invitation: {
    heading: 'Our invitation',
    paragraphs: [
      'Are you a good person who puts intelligence and competence over dogma, money and power? Then this is your house. Come with reason, come with curiosity, come with kindness — and help us spread a little light.',
    ],
    motto: 'Aude sapere — dare to know.',
  },
  disclaimer:
    'Original Illuminati is a modern organisation inspired by the historical Illuminati order of 1776. It makes no claim to be that historical order or its legal successor.',
} as const;
